var map = {
	"./de.json": 690081,
	"./en.json": 309236,
	"./es.json": 968142,
	"./fr.json": 215808,
	"./it.json": 560633,
	"./ja.json": 280965,
	"./ko.json": 220245,
	"./pl.json": 530437,
	"./pt.json": 84689,
	"./ru.json": 640069,
	"./uk.json": 639472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629631;